export default __webpack_public_path__ + "static/media/iconInstagram.2e1d114d.svg";